import type { FC, ReactNode } from 'react';

import styles from './Section.module.scss';

interface ISection {
  title: ReactNode | null;
  customButton?: ReactNode;
  id?: string;
  type?: 'group' | 'list';
  titleId?: string;
  border?: 'none';
}

export const Section: FC<ISection> = ({ title, children, customButton, id, type, titleId, border }) => {
  const sectionAttributes = {
    ...(border === 'none' && { 'data-border-none': true }),
  };

  const titleContainerAttributes = {
    ...(type === 'list' && { 'data-list': true }),
  };

  const titleAttributes = {
    ...(type !== 'group' && { 'data-margin': true }),
    ...(type === 'group' && { 'data-group': true }),
  };

  return (
    <section className={styles.Section} id={id} {...sectionAttributes}>
      <div className={styles.TitleContainer} {...titleContainerAttributes}>
        {!!title && (
          <h2 className={styles.Title} id={titleId} {...titleAttributes}>
            {title}
          </h2>
        )}
        {customButton}
      </div>
      {children}
    </section>
  );
};
